import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../App.css';

const PagoCanceladoPage = () => {
  const [searchParams] = useSearchParams();
  const orden = searchParams.get('orden') || '';

  return (
    <div className="main-container">
      <Header />
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' }}>
        <div style={{ textAlign: 'center', maxWidth: '480px' }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>✕</div>
          <h1 style={{ fontSize: '24px', marginBottom: '12px', color: '#ef4444' }}>Pago cancelado</h1>
          <p style={{ color: '#6b7280', marginBottom: '24px', lineHeight: 1.6 }}>
            El pago no se completó. Tu pedido permanece pendiente.
            {orden && (
              <span style={{ display: 'block', marginTop: '8px', fontWeight: 600, color: '#374151' }}>
                Pedido: {orden}
              </span>
            )}
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link
              to="/checkout"
              style={{
                display: 'inline-block',
                padding: '14px 28px',
                background: '#dc2626',
                color: 'white',
                borderRadius: '8px',
                fontWeight: 600,
                textDecoration: 'none'
              }}
            >
              Intentar de nuevo
            </Link>
            <Link
              to="/shop"
              style={{
                display: 'inline-block',
                padding: '14px 28px',
                background: '#f3f4f6',
                color: '#374151',
                borderRadius: '8px',
                fontWeight: 600,
                textDecoration: 'none'
              }}
            >
              Volver a la tienda
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PagoCanceladoPage;
